import axios from 'axios'
import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    name: null,
    status: 3,
    page: null,
    reconnect: 5,
    dateStart: null,
    dateStartConnexion: null,
    dbSource: null,
    dbExport: null,
    connected: false,
    user: null,
    live: null,
    open: false,
    clockOffset: null,
    clockInterval: null,
    users: []
  },
  mutations: {
    name: (state, value) => { state.name = value },
    page: (state, value) => {
      state.page = value
      socket.page()
    },
    status: (state, value) => { state.status = value },
    reconnect: (state, value) => { state.reconnect = value },
    close: (state, value) => {
      state.status = value
      state.dateStartConnexion = null
    },
    set: (state, content) => {
      state.dateStartConnexion = (new Date()).getTime()
      if (content.dbSource) {
        state.dbSource = content.dbSource
      }
      if (content.dbExport) {
        state.dbExport = content.dbExport
      }
      if (content.connected) {
        state.connected = content.connected
      }
      if (content.user) {
        state.user = content.user
      }
    },
    updateClockOffset (state, dateTime) {
      state.clockOffset = new Date(dateTime).getTime() - new Date().getTime()
    },
    live (state) {
      const live = new Date()
      live.setTime(new Date().getTime() + state.clockOffset)
      state.live = live
    },
    open: (state) => { state.open = localStorage.getItem('monitoringOpen') === 'true' },
    addUser: (state, user) => { state.users.push(user) },
    delUser: (state, id) => {
      const index = state.users.findIndex((user) => user.id === id)
      if (index) {
        state.users.splice(index, 1)
      }
    },
    updateUser: (state, content) => {
      const user = state.users.find((user) => user.id === content.id)
      if (user) {
        user[content.key] = content.value
      }
    }
  },
  actions: {
    async live ({ commit, state }) {
      if (state.clockInterval) { clearInterval(state.clockInterval) }
      let dateTime
      await axios.get('https://time.api.idalgo.idalgo-hosting.com')
        .then(function (response) {
          dateTime = response.data.dateTime
        })
        .catch(function () {
          const dateNow = new Date()
          dateTime = dateNow.toISOString()
        })
      commit('updateClockOffset', dateTime)
      state.clockInterval = setInterval(() => { commit('live') }, 1000)
    },
    open: ({ commit, state }) => {
      localStorage.setItem('monitoringOpen', !state.open)
      commit('open')
    }
  },
  getters: {
    connected: (state) => state.connected,
    dateStart: (state) => state.dateStart,
    dateStartConnexion: (state) => state.dateStartConnexion,
    page: (state) => state.page,
    dbExport: (state) => state.dbExport,
    dbSource: (state) => state.dbSource,
    name: (state) => state.name,
    reconnect: (state) => state.reconnect,
    status: (state) => state.status,
    user: (state) => state.user,
    live: (state) => state.live,
    liveOffset: (state) => state.clockOffset,
    local: (state) => state.local,
    open: (state) => state.open,
    users: (state) => state.users,
    userConnected: (state) => (id) => { return state.users.findIndex((user) => { return user.userId === id }) > -1 },
    userConnectedPath: (state) => (id, path) => { return state.users.findIndex((user) => { return user.userId === id && user.path === path }) > -1 }
  }
}
